import { jsx as _jsx } from "react/jsx-runtime";
import { MobileLinksList } from './MobileLinksList';
const SUPPORT_LINKS = [
    {
        url: '/about-shipping',
        name: 'Shipping & returns',
    },
    {
        url: '/about-faq',
        name: 'Help/FAQ',
    },
    {
        url: '/about-regulations',
        name: 'Terms of use',
    },
    {
        url: '/about-mounting',
        name: 'Mounting instructions',
    },
    {
        url: '/about-copyright',
        name: 'Copyrights',
    },
    {
        url: '/about-privacy',
        name: 'Privacy',
    },
    {
        url: '/about-contact',
        name: 'Contact us',
    },
];
export const SupportSubNavigation = () => _jsx(MobileLinksList, { links: SUPPORT_LINKS }, void 0);
//# sourceMappingURL=SupportSubNavigation.js.map